import { Link, Outlet, useLocation } from "react-router-dom"
import Dasboard from "../../../../../Components/Icons/Dasboard";
import { useEffect, useState } from "react";
import SearchBar from "../../../../../Components/Utils/SearchBar";
import { CreateButton, FilterButton } from "../../../../../Components/Utils/Buttons";
import { Select } from "antd";
import { GetAccess } from "../../../../../Components/Utils/roles";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";


const PaymentsLayout = (
    {
        SearchData=() => {},
        setSearchQuery=()=>{},
        CreateAccess= true,
        ImportAccess= true,
        setOpen=()=>{},
        children,
        handleSearch=()=>{},
        searchBy="",
        setFilterOpen=()=>{},
        isFilter,
        ClearFilter=()=>{},
        officeId,
        projectId
    }
) =>{
    let {pathname} = useLocation()
    const [module,setModule] = useState("")
    
    
    let searchList = [
        { value: "all", label: "All" },
        { value: "services", label: "Services" },
        { value: "products", label: "Products" },
      ];

    useEffect(() =>{
        if(pathname == `/project/payments/invoice-in/${officeId}/${projectId}`){
            setModule("Incoming")
        }else if(pathname == `/project/payments/invoice-out/${officeId}/${projectId}`){
            setModule("Outgoing")
        }else if(pathname == `/project/payments/other-expenses/${officeId}/${projectId}`){
            setModule("Other Expenses")
        }
    },[pathname])

    let LinkItem = [
        {
            label:"Incoming",
            link:`/project/payments/invoice-in/${officeId}/${projectId}`,
            access:GetAccess(),
        },
        {
            label:"Outgoing",
            link:`/project/payments/invoice-out/${officeId}/${projectId}`,
            access:GetAccess(),
        },
        {
            label:"Other Expenses",
            link:`/project/payments/other-expenses/${officeId}/${projectId}`,
            access:GetAccess(),
        },
    ]
    
    return(
        <div className=" w-full h-full py-2 px-4 ">
            <div className="">
            <div className="md:flex justify-end w-full">
            {/* <Breadcrumb items={[
                // {
                //     name:"Office"
                // },
                {
                    name:"Project"
                },
                {
                    name:module
                }
            ]} /> */}

<div className=" w-full h-8 flex items-center gap-x-4 ">
            {
                LinkItem && LinkItem.map((item, i) => {
                    return(
                        <>
                         {
                            item.access && (
                                // <Link to={item?.link} style={item?.link == pathname ?{borderBottom:"4px solid #119DEE"}:{borderBottom:"4px solid transparent"}} className={` pb-1 text-[13px] font-medium text-mainColor-400 hover:text-mainColor-400 ${item?.link == pathname ?"border-b-4 border-red":""}   `}  key={item?.link} >{item?.label||""}</Link>
                                <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>

                            )
                         }
                        </>
                    )
                })
            }
        </div>


            <div className=" flex justify-end items-center gap-3 mr-6">
            <form className="flex items-center gap-3 mx-0" onSubmit={SearchData}>
              <SearchBar handleChange={(e) => setSearchQuery(e.target.value)} />
              </form>
              <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
              {isFilter&& <FilterButton label='Clear Filter'  handleClick={ClearFilter} />}
              {/* {ImportAccess && <CreateButton label="Import" handleClick={()=>setOpen(true)}    />} */}

              {CreateAccess && <Link to={`${pathname}/create`}><CreateButton label={module}/></Link>}
                  {/* <BackButton/> */}
                </div>
            </div>
           
            
           
            <div className=" w-full h-[calc(100vh-140px)] bg-white mt-2">
               {children} 
            </div>
            </div>
        </div>
    )
}


export default PaymentsLayout;